<template>
    <v-dialog v-model="dialog" max-width="600" scrollable>
        <v-card >
            <v-card-title class="pb-1">
                <div class="title font-weight-light">Detalles de la cita</div>
                <v-spacer></v-spacer>
                <v-icon @click="hide">close</v-icon>
            </v-card-title>
            <v-card-title v-if="title" class="py-0">
                <div class="subtitle font-weight-light">{{title}}</div>
            </v-card-title>

            <v-card-text v-if="event">
                <attention-summary :event="event" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>

    import AttentionSummary from "../appointments/attention/AttentionSummary";
    export default{
        components: {AttentionSummary},
        data(){
            return {
                dialog: false,
                event: null
            }
        },
        methods:{
            show(evt){
                var vm = this
                vm.dialog = true
                vm.event = evt

            },
            hide(){
                var vm = this
                vm.dialog = false
            }
        },
        computed: {
          title(){
              var vm = this
              if(!vm.event) return ''

              return vm.$moment(vm.event.date).format('ddd') + ', ' +
                  vm.$moment(vm.event.date).format('D') + ' ' +
                  vm.$moment(vm.event.date).format('MMMM') + ' del ' +
                  vm.$moment(vm.event.date).format('YYYY') + ' | ' +
                  vm.$moment( vm.event.time, 'HH:mm:ss').format('HH:mm') + ' hrs.'
          }
        },
        watch:{
            dialog(val){
                if(!val){
                    var vm = this
                    setTimeout(function(){
                        vm.event = null
                    }, 500)
                }
            }
        }
    }
</script>